import React from "react";
import RatingListContainerWithTariffs from "./Containers/RatingListContainerWithTariffs";
import Filters from "./Containers/Filters";
import { observer, inject } from "mobx-react";
import { graphql } from "@apollo/client/react/hoc";
import orderBy from "lodash/orderBy";
import { RATING_TABLE_QUERY_AGGREGATE } from "Services/queries";
import queryString from "query-string";
import { withRouter } from "react-router-dom";
import withDefaultParams, { generateUrl } from "Services/withDefaultParams";
import Stub from "./Containers/Stub";
import ProviderConnectHOC from "HOC/ProviderConnectHOC";
import InfoContainer from "./Containers/InfoContainer";
import HowCalcRatingContainer from "Containers/HowCalcRatingContainer";
import configRouters from "Configs/routes";
import { Helmet } from "react-helmet-async";
import Container from "reactstrap/lib/Container";
import Districts from "Containers/DistrictsContainer";
import DeclinationContainerNew from "Containers/DeclinationContainerNew";
import FilterInfo from "./Components/FilterInfo";
import { isMainSiteCode } from "Utils/siteConfig";

@observer
class RatingTable extends React.Component {
	canonical() {
		const {
			ApplicationModel: { siteConfig },
		} = this.props;

		const location = generateUrl(configRouters.Rating.route, this.props.match.params);

		return (
			<Helmet>
				<link
					rel="canonical"
					href={`${siteConfig.ssl === true ? `https` : "http"}://${
						siteConfig.domain_name_full
					}${location}`}
				/>
			</Helmet>
		);
	}

	render() {
		if (!this.props.providers) return <Stub />;
		let {
			ApplicationModel: { windowSizeModel, siteCode },
			providers: { data },
			aggregation,
		} = this.props;

		let text = this.props.ApplicationModel.text;

		let sortedAggregation = {};
		for (let it in aggregation) {
			sortedAggregation[it] = orderBy(aggregation[it], "name", "asc");
		}

		return (
			<React.Fragment>
				{this.canonical()}
				{isMainSiteCode(siteCode) && <div></div>}
				<FilterInfo
					filterElement={<Filters aggregation={sortedAggregation} />}
					additionalInfo={
						<HowCalcRatingContainer>
							<InfoContainer texts={text} />
						</HowCalcRatingContainer>
					}
				/>

				<ProviderConnectHOC>
					<RatingListContainerWithTariffs
						items={data}
						text={text}
						match={this.props.match}
						windowSizes={windowSizeModel.windowSizes}
					/>
				</ProviderConnectHOC>
				<Container>
					<DeclinationContainerNew>
						<Districts />
					</DeclinationContainerNew>
				</Container>
			</React.Fragment>
		);
	}
}

export default withRouter(
	withDefaultParams(
		inject("ApplicationModel")(
			graphql(RATING_TABLE_QUERY_AGGREGATE, {
				skip: (ownProps) => {
					return ownProps.match.params.regionUrl ? false : true;
				},
				options: (props) => {
					let filter = [];
					let variables = {};
					let inMainRating = 1;
					let params = queryString.parse(props.location.search);
					if (params.providers) {
						filter.push(`id=${params.providers}`);
					}
					if (params.service) {
						inMainRating = params.service;
						// filter.push(`order_types.id=${params.service}`);
					}
					if (props.match.params.regionUrl) {
						filter.push(`region.url=${props.match.params.regionUrl}`);
						variables.filter = filter.join("&");
						variables.filterAggregate = `region.url=${props.match.params.regionUrl}`;
						variables.urlName = props.match.params.regionUrl;
						variables.filterRegion = `url=${props.match.params.regionUrl}`;
					}
					return {
						variables: {
							...variables,
							inMainRating: parseInt(inMainRating),
							sort: "rating.order_types.order_type_id,rating.order_types.position",
						},
					};
				},
				props: ({ ownProps, data }) => {
					if (data.providers) {
						let {
							ApplicationModel: { filtersModel },
						} = ownProps;
						filtersModel.setFiltersAvalable(data.providersAggregate.aggregation);
						return {
							providers: data.providers,
							aggregation: data.providersAggregate.aggregation,
						};
					}
					return null;
				},
			})(RatingTable)
		)
	)
);
